var htCarousel = {
  container : '.hcarousel',

  slides : '.hcarousel ul.slides',

  hasCss3 : true,

  init : function() {
    if ( !$(this.container).get(0) ) {
      return;
    }

    $('li:first-child', this.slides).addClass('activeSlide');
    this.refreshImages();

    this.hasCss3 = this.checkCss3();
    this.setUlWidth();
    this.setArrows();
    this.setListeners();
      
      
  },

  setListeners : function() {
    var self = this;

    $(window).resize( function() {
      self.refreshImages();
      self.setUlWidth();
      self.setArrows();
      self.adjustMobile();
    });
   
    $('.flex-next', this.container).click( function() {
      self.moveNext();
    });

    $('.flex-prev', this.container).click( function() {
      self.movePrev();
    });

    $('.templatePageCollection #scroll-content').swipe({
      swipeLeft:function(event, direction, distance, duration, fingerCount) { 
        self.moveNext();
      },
      swipeRight:function(event, direction, distance, duration, fingerCount) { 
        self.movePrev();
      }
    });

  },
  
  setUlWidth : function() {
    var w = 0;
    
    $('li', this.slides).each( function() {
      	w += $(this).width();
    });
    
    $(this.slides).width( w + 2 );
  },

  setArrows : function() {
    var ulwidth = 0;
    var liswidth = 0;

    $('li', this.slides).each(function() {
      ulwidth += $(this).outerWidth();
      if ( $(this).index() < $('li.activeSlide', this.container).index() ) {
        liswidth += $(this).outerWidth();
      }
    });
    
    
    if( ulwidth > $(this.container).width()) {
      $('.flex-next', this.container).removeClass('flex-disabled');
    }
    else if ( !$('.flex-next', this.container).hasClass('flex-disabled') ) {
      $('.flex-next', this.container).addClass('flex-disabled');
    }
      
    this.setLeft( Math.min(-1 * liswidth, 0) + 'px' );
  },

  moveNext : function() {
    var nextSlide = $('.activeSlide').next();
    if ( !nextSlide.get(0) || $('.flex-next', this.container).hasClass('flex-disabled') ) {
      return; 
    }
   
    var ulwidth = 0;
    var liswidth = 0;

    $('li', this.slides).each(function() {
      ulwidth += $(this).outerWidth();
      if ( $(this).index() < nextSlide.index() ) {
        liswidth += $(this).outerWidth();
      }
    });
   
    var maxleft = ulwidth - $(this.container).width();
    if ( maxleft < 0 ) {
      maxleft = 0;
    }
    //var left =  -1 * (Math.min ( nextSlide.offset().left + Math.abs(currLeft), maxleft) );
    var left = -1 * Math.min(liswidth, maxleft);
    
    left = left + 'px';
    
    this.setLeft( left );
    
    $('.activeSlide').removeClass('activeSlide');
    nextSlide.addClass('activeSlide');
    $('.flex-prev', this.container).removeClass('flex-disabled');
    if ( !nextSlide.next().get(0) || maxleft === Math.abs(parseInt(left)) ) {
      $('.flex-next', this.container).addClass('flex-disabled');
    }
  },

  movePrev : function() {
    var prevSlide = $('.activeSlide').prev();
    if ( !prevSlide.get(0) || $('.flex-prev', this.container).hasClass('flex-disabled') ) {
      return; 
    }
    
    var liswidth = 0;

    $('li', this.slides).each(function() {
      if ( $(this).index() < prevSlide.index() ) {
        liswidth += $(this).outerWidth();
      }
    });
   
    //var left =  ( -1 * (Math.abs(currLeft) - Math.abs(prevSlide.offset().left)) );
    var left = -1 * liswidth;
    
    left = Math.min(left, 0) + 'px';
    
    this.setLeft( left );
    
    $('.activeSlide').removeClass('activeSlide');
    prevSlide.addClass('activeSlide');
    $('.flex-next', this.container).removeClass('flex-disabled');
    if ( !prevSlide.prev().get(0) ) {
      $('.flex-prev', this.container).addClass('flex-disabled');
    }
  },

  setLeft : function( left ) {
    if( this.hasCss3 ) {
      $(this.slides).css({'-webkit-transform': 'translate3d(' + left + ',0,0)',
                              '-moz-transform': 'translate3d(' + left + ',0,0)',
                              '-ms-transform': 'translate3d(' + left + ',0,0)',
                              'transform': 'translate3d(' + left + ',0,0)'});
      }
      else {
        $(this.slides).css('left', left);
      }
  },
  
  adjustMobile : function() {
    if ( $(window).width() < 480 ) {
      $('.hcarousel ul.slides li').width( $(window).width() );
    }
    else {
      $('.hcarousel ul.slides li').width( 'auto' );
    }
      
  },

  refreshImages : function() {
    $('li img', this.slides).css('display','inline');
    setTimeout( function() {
      $('li img', this.slides).css('display','inline-block');
    },50);
  },

  checkCss3 : function() {
    var prefixes = 'transform WebkitTransform MozTransform OTransform msTransform'.split(' ');
      for(var i = 0; i < prefixes.length; i++) {
          if(document.createElement('div').style[prefixes[i]] !== undefined) {
              return prefixes[i];
          }
      }
      return false;
  },
  
  showImages : function() {
  }
}